//NOTE: GJ: we're manually calling `this.notifyPropertyChange('length')` to avoid a likely framework bug
//          which caused tests in https://github.com/intercom/embercom-composer/pull/2842/files to
//          fail (when they where updated to our non-bindings interface). Em.ArrayProxy seems to have
//          a rich history of bugs and code churn, the issue may be fixed in a newer ember version
//          (we're seeing this issue on 2.4.5). We should check if we can remove the hack in newer
//          framework versions. We should also try to remove our use of Em.ArrayProxy in future, it seems
//          overkill and brings a bunch of complexity

import Em from 'ember';
export default Em.Mixin.create({
  addObject(obj) {
    this._assertValid(obj);
    this._super(obj);
    this.notifyPropertyChange('length');
  },
  addObjects(objs) {
    objs.forEach(this._assertValid, this);
    this._super(objs);
    this.notifyPropertyChange('length');
  },
  insertAt(idx, obj) {
    this._assertValid(obj);
    this._super(idx, obj);
    this.notifyPropertyChange('length');
  },
  pushObject(obj) {
    this._assertValid(obj);
    this._super(obj);
    this.notifyPropertyChange('length');
  },
  pushObjects(objs) {
    objs.forEach(this._assertValid, this);
    this._super(objs);
    this.notifyPropertyChange('length');
  },
  replace(idx, amt, objs) {
    objs.forEach(this._assertValid, this);
    this._super(idx, amt, objs);
    this.notifyPropertyChange('length');
  },
  setObjects(objs) {
    objs.forEach(this._assertValid, this);
    this._super(objs);
    this.notifyPropertyChange('length');
  },
  unshiftObject(obj) {
    this._assertValid(obj);
    this._super(obj);
    this.notifyPropertyChange('length');
  },
  unshiftObjects(objs) {
    objs.forEach(this._assertValid, this);
    this._super(objs);
    this.notifyPropertyChange('length');
  },
  _assertValid(obj) {
    if (Em.isNone(obj) || !this.validate(obj)) {
      throw new Error('tried to add an invalid object');
    }
  }
});